import { FC } from "react";

import { Spacer } from "shared/layout";
import { copy } from "shared/assets";
import { Button, Card } from "shared/components";
import { Icon, MutedDarkText } from "shared/styles";
import { Plus } from "shared/assets/icons";
import { ICardTheme } from "shared/types";

const { venueBlock: venueBlockCopy } = copy;

interface AddVenueCTAProps {
  handleClick: () => void;
}

export const AddVenueCTA: FC<AddVenueCTAProps> = ({ handleClick }) => {
  return (
    <Card theme={ICardTheme.secondary}>
      <Spacer size="xs">
        <MutedDarkText>{venueBlockCopy.createVenue.cta}</MutedDarkText>
        <Button onClick={handleClick} data-testid="add_venue_cta">
          <Icon as={Plus} />
          <span>{venueBlockCopy.buttons.createVenue}</span>
        </Button>
      </Spacer>
    </Card>
  );
};
